import { Observable } from 'rxjs';
import { combineEpics } from 'redux-observable';
import { INIT, LOADING, SUCCESS, ERROR } from '../../utils/constants';
import { getCountriesAPI, createCampaignAPI, getAppCampaignsAPI, patchCampaignAPI, attachMediaAPI, getCampaignAPI, updateCampaignAPI } from './api';

export const GET_COUNTRIES = 'advaice/create-campaign/GET_COUNTRIES';
export const GET_COUNTRIES_SUCCESS = 'advaice/create-campaign/GET_COUNTRIES_SUCCESS';
export const GET_COUNTRIES_ERROR = 'advaice/create-campaign/GET_COUNTRIES_ERROR';

export const CREATE_CAMPAIGN = 'advaice/create-campaign/CREATE_CAMPAIGN';
export const CREATE_CAMPAIGN_SUCCESS = 'advaice/create-campaign/CREATE_CAMPAIGN_SUCCESS';
export const CREATE_CAMPAIGN_ERROR = 'advaice/create-campaign/CREATE_CAMPAIGN_ERROR';

export const GET_APP_CAMPAIGNS = 'advaice/create-campaign/GET_APP_CAMPAIGNS';
export const GET_APP_CAMPAIGNS_SUCCESS = 'advaice/create-campaign/GET_APP_CAMPAIGNS_SUCCESS';
export const GET_APP_CAMPAIGNS_ERROR = 'advaice/create-campaign/GET_APP_CAMPAIGNS_ERROR';

export const SET_FORM_STATE = 'advaice/create-campaign/SET_FORM_STATE';
export const RESET_STORE = 'advaice/create-campaign/RESET_STORE';

export const PATCH_CAMPAIGN = 'advaice/create-campaign/PATCH_CAMPAIGN';
export const PATCH_CAMPAIGN_SUCCESS = 'advaice/create-campaign/PATCH_CAMPAIGN_SUCCESS';
export const PATCH_CAMPAIGN_ERROR = 'advaice/create-campaign/PATCH_CAMPAIGN_ERROR';

export const GET_PATCH_CAMPAIGN_SUCCESS = 'advaice/create-campaign/GET_PATCH_CAMPAIGN_SUCCESS';
export const GET_PATCH_CAMPAIGN_ERROR = 'advaice/create-campaign/GET_PATCH_CAMPAIGN_ERROR';

export const ATTACH_MEDIA = 'advaice/create-campaign/ATTACH_MEDIA';
export const ATTACH_MEDIA_SUCCESS = 'advaice/create-campaign/ATTACH_MEDIA_SUCCESS';
export const ATTACH_MEDIA_ERROR = 'advaice/create-campaign/ATTACH_MEDIA_ERROR';

export const GET_CAMPAIGN = 'advaice/create-campaign/GET_CAMPAIGN';
export const GET_CAMPAIGN_SUCCESS = 'advaice/create-campaign/GET_CAMPAIGN_SUCCESS';
export const GET_CAMPAIGN_ERROR = 'advaice/create-campaign/GET_CAMPAIGN_ERROR';

export const UPDATE_CAMPAIGN = 'advaice/create-campaign/UPDATE_CAMPAIGN';
export const UPDATE_CAMPAIGN_SUCCESS = 'advaice/create-campaign/UPDATE_CAMPAIGN_SUCCESS';
export const UPDATE_CAMPAIGN_ERROR = 'advaice/create-campaign/UPDATE_CAMPAIGN_ERROR';

export const ANNUL_CREATE_ERROR = 'advaice/create-campaign/ANNUL_CREATE_ERROR';

export const ANNUL_PATCH_ERROR = 'advaice/create-campaign/ANNUL_PATCH_ERROR';

export const RESET_CREATE_CAMPAIGN_FORM = 'advaice/create-campaign/RESET_CREATE_CAMPAIGN_FORM';


const initialState = {
  countriesStatus: INIT,
  error: '',
  countries: [],
  campaignId: '',
  formState: {
    hasState: false,
    data: {},
  },
  currentAppCampaigns: [],
  hasMoreCurrentAppCampaigns: true,
  getCampaignStatus: INIT,
  getCampaignError: '',
  getAppCampaignsStatus: INIT,
  getAppCampaignsError: '',
  createCampaignStatus: INIT,
  currentEditableCampaign: {},
  createCampaignError: '',
  patchCampaignStatus: INIT,
  patchCampaignError: '',
  attachMediaStatus: INIT,
  attachMediaError: '',

};

export const campaignStore = (state = initialState, action = {}) => {
  switch (action.type) {
    case GET_COUNTRIES: {
      return {
        ...state,
        countriesStatus: LOADING,
      };
    }
    case GET_COUNTRIES_SUCCESS: {
      return {
        ...state,
        countriesStatus: SUCCESS,
        countries: [...state.countries, ...action.payload.data],
      };
    }
    case CREATE_CAMPAIGN: {
      return {
        ...state,
        createCampaignStatus: LOADING,
      };
    }
    case CREATE_CAMPAIGN_SUCCESS: {
      return {
        ...state,
        createCampaignStatus: SUCCESS,
        campaignId: action.payload.data.id,
      };
    }
    case CREATE_CAMPAIGN_ERROR: {
      return {
        ...state,
        createCampaignStatus: ERROR,
        createCampaignError: action.payload,
      };
    }
    case ANNUL_CREATE_ERROR: {
      return {
        ...state,
        createCampaignStatus: INIT,
        createCampaignError: '',
      };
    }
    case PATCH_CAMPAIGN_SUCCESS: {
      return {
        ...state,
        patchCampaignStatus: SUCCESS,
      };
    }
    case PATCH_CAMPAIGN_ERROR: {
      return {
        ...state,
        patchCampaignStatus: ERROR,
        patchCampaignError: action.payload,
      };
    }
    case ANNUL_PATCH_ERROR: {
      return {
        ...state,
        patchCampaignStatus: INIT,
        patchCampaignError: '',
      };
    }
    case ATTACH_MEDIA: {
      return {
        ...state,
        attachMediaStatus: LOADING,
      };
    }
    case ATTACH_MEDIA_SUCCESS: {
      return {
        ...state,
        attachMediaStatus: SUCCESS,
      };
    }
    case ATTACH_MEDIA_ERROR: {
      return {
        ...state,
        attachMediaStatus: ERROR,
        attachMediaError: action.payload,

      };
    }
    case GET_CAMPAIGN: {
      return {
        ...state,
        getCampaignStatus: LOADING,
      };
    }
    case GET_CAMPAIGN_SUCCESS: {
      return {
        ...state,
        getCampaignStatus: SUCCESS,
        currentEditableCampaign: action.payload.data,
        getCampaignError: '',
      };
    }
    case GET_CAMPAIGN_ERROR: {
      return {
        ...state,
        getCampaignStatus: ERROR,
        getCampaignError: action.payload,

      };
    }
    case GET_PATCH_CAMPAIGN_SUCCESS: {
      return {
        ...state,
        getCampaignStatus: SUCCESS,
        currentEditableCampaign: action.payload.data,
        getCampaignError: '',
      };
    }
    case UPDATE_CAMPAIGN: {
      return {
        ...state,
        createCampaignStatus: LOADING,
      };
    }
    case UPDATE_CAMPAIGN_SUCCESS: {
      return {
        ...state,
        createCampaignStatus: SUCCESS,
        campaignId: action.payload.data.id,
      };
    }
    case UPDATE_CAMPAIGN_ERROR: {
      return {
        ...state,
        createCampaignStatus: ERROR,
        createCampaignError: action.payload,

      };
    }
    case SET_FORM_STATE: {
      return {
        ...state,
        formState: {
          ...state.formState,
          hasState: true,
          data: {
            ...state.formState.data,
            ...action.payload,
          },
        },
      };
    }
    case RESET_STORE: {
      return {
        ...state,
        countriesStatus: INIT,
        error: '',
        countries: [],
        campaignId: '',
        attachMediaStatus: INIT,
        formState: {

          hasState: false,
          data: {},
        },
        createCampaignStatus: INIT,
        createCampaignError: '',
      };
    }
    case GET_APP_CAMPAIGNS: {
      return {
        ...state,
        getAppCampaignsStatus: LOADING,

      };
    }
    case GET_APP_CAMPAIGNS_SUCCESS: {
      return {
        ...state,
        getAppCampaignsStatus: SUCCESS,
        currentAppCampaigns: [...action.payload.data],
      };
    }
    case GET_APP_CAMPAIGNS_ERROR: {
      return {
        ...state,
        getAppCampaignsStatus: ERROR,
        getAppCampaignsError: action.payload,
      };
    }
    case PATCH_CAMPAIGN: {
      return {
        ...state,
        patchCampaignStatus: LOADING,
      };
    }
    case RESET_CREATE_CAMPAIGN_FORM: {
      return {
        ...state,
        currentAppCampaigns: [],
        currentEditableCampaign: {},
        getCampaignStatus: INIT,
        getCampaignError: '',
        getAppCampaignsStatus: INIT,
        getAppCampaignsError: '',
        createCampaignStatus: INIT,
        createCampaignError: '',
        campaignId: '',
      };
    }
    default: {
      return state;
    }
  }
};

export const getCountries = () => ({
  type: GET_COUNTRIES,
});

export const getAppCampaigns = data => ({
  type: GET_APP_CAMPAIGNS,
  payload: data,
});

export const annulCreateError = () => ({
  type: ANNUL_CREATE_ERROR,
});
export const annulPatchError = () => ({
  type: ANNUL_PATCH_ERROR,
});
export const createCampaign = data => ({
  type: CREATE_CAMPAIGN,
  payload: data,
});

export const setFormState = data => ({
  type: SET_FORM_STATE,
  payload: data,
});

export const resetCampaignStore = () => ({
  type: RESET_STORE,
});

export const getCampaign = data => ({
  type: GET_CAMPAIGN,
  payload: data,
});

export const patchCampaign = data => ({ type: PATCH_CAMPAIGN, payload: data });


export const attachMedia = data => ({ type: ATTACH_MEDIA, payload: data });

export const updateCampaign = data => ({ type: UPDATE_CAMPAIGN, payload: data });

export const resetCreateCampaignForm = () => ({
  type: RESET_CREATE_CAMPAIGN_FORM,
});

export const getCountriesObservable = () => Observable
  .fromPromise(getCountriesAPI())
  .map(data => ({ type: GET_COUNTRIES_SUCCESS, payload: data }))
  .catch(err => Observable.of({ type: GET_COUNTRIES_ERROR, payload: err }));

export const createCampaignObservable = (store, requestData) => Observable
  .fromPromise(createCampaignAPI(requestData))
  .map(data => ({ type: CREATE_CAMPAIGN_SUCCESS, payload: data }))
  .catch(err => Observable.of({ type: CREATE_CAMPAIGN_ERROR, payload: err }));

export const getAppCampaignsObservable = (store, requestData) => Observable
  .fromPromise(getAppCampaignsAPI(requestData))
  .map(data => ({ type: GET_APP_CAMPAIGNS_SUCCESS, payload: data }))
  .catch(err => Observable.of({ type: GET_APP_CAMPAIGNS_ERROR, payload: err }));

export const patchCampaignObservable = (store, requestData) => Observable
  .fromPromise(patchCampaignAPI(requestData))
  .map(data => ({ type: PATCH_CAMPAIGN_SUCCESS, payload: data }))
  .catch(err => Observable.of({ type: PATCH_CAMPAIGN_ERROR, payload: err }));

export const attachMediaObservable = (store, requestData) => Observable
  .fromPromise(attachMediaAPI(requestData))
  .map(data => ({ type: ATTACH_MEDIA_SUCCESS, payload: data }))
  .catch(err => Observable.of({ type: ATTACH_MEDIA_ERROR, payload: err }));

export const getCampaignObservable = (store, requestData) => Observable
  .fromPromise(getCampaignAPI(requestData))
  .map(data => ({ type: GET_CAMPAIGN_SUCCESS, payload: data }))
  .catch(err => Observable.of({ type: GET_CAMPAIGN_ERROR, payload: err }));

export const updateCampaignObservable = (store, requestData) => Observable
  .fromPromise(updateCampaignAPI(requestData))
  .map(data => ({ type: UPDATE_CAMPAIGN_SUCCESS, payload: data }))
  .catch(err => Observable.of({ type: UPDATE_CAMPAIGN_ERROR, payload: err }));

export const getCountriesEpic = (action$, store) => action$
  .ofType(GET_COUNTRIES)
  .flatMap(action => getCountriesObservable(store, action.payload));

export const createCampaignEpic = (action$, store) => action$
  .ofType(CREATE_CAMPAIGN)
  .flatMap(action => createCampaignObservable(store, action.payload));

export const getAppCampaignsEpic = (action$, store) => action$
  .ofType(GET_APP_CAMPAIGNS)
  .flatMap(action => getAppCampaignsObservable(store, action.payload));

export const patchCampaignEpic = (action$, store) => action$
  .ofType(PATCH_CAMPAIGN)
  .flatMap(action => patchCampaignObservable(store, action.payload));

export const attachMediaEpic = (action$, store) => action$
  .ofType(ATTACH_MEDIA)
  .flatMap(action => attachMediaObservable(store, action.payload));

export const getCampaignEpic = (action$, store) => action$
  .ofType(GET_CAMPAIGN)
  .flatMap(action => getCampaignObservable(store, action.payload));

export const updateCampaignEpic = (action$, store) => action$
  .ofType(UPDATE_CAMPAIGN)
  .flatMap(action => updateCampaignObservable(store, action.payload));

export const campaignEpic = combineEpics(
  getCountriesEpic,
  createCampaignEpic,
  getAppCampaignsEpic,
  patchCampaignEpic,
  attachMediaEpic,
  getCampaignEpic,
  updateCampaignEpic,
);



// WEBPACK FOOTER //
// ./src/reducers/create-campaign/duck.js